export default {
    area: 54.57250140793089,
    exclude_break: true,
    floor_height: 2.81,
    id: 'DEF1D412-8834-45E9-A4F9-3641BFF7774A',
    mep: {
        category: {
            hard_dec: {
                items: [
                    {
                        branch: '',
                        id: '21891268-EDAB-4227-21F1-91E8BCB7EA19',
                        name: '壁灯23',
                        price: 20.0,
                        quantity: 2,
                        specification: '485*266*575',
                        thumbnail:
                            'https://www-test.foxithd.com/b/static/media/hd_ent_logo.6138aa8f.svg',
                        unit: '个',
                        unit_price: 10.0,
                    },
                    {
                        branch: '',
                        id: '08A13A7F-92EC-4DF4-D0E6-477BFB52F722',
                        name: '强电箱_1',
                        price: 10.0,
                        quantity: 1,
                        specification: '246*54*165',
                        thumbnail:
                            'https://www-test.foxithd.com/b/static/media/hd_ent_logo.6138aa8f.svg',
                        unit: '个',
                        unit_price: 10.0,
                    },
                    {
                        branch: '',
                        id: 'CDBECE5B-D1A3-4526-5C07-9BA68E725FDC',
                        name: '三联单控_1',
                        price: 10.0,
                        quantity: 1,
                        specification: '85*17*85',
                        thumbnail:
                            'https://www-test.foxithd.com/b/static/media/hd_ent_logo.6138aa8f.svg',
                        unit: '个',
                        unit_price: 10.0,
                    },
                    {
                        branch: '',
                        id: '7C27AB50-B1B5-4C38-444C-7C0F1BF6C625',
                        name: '强电插座',
                        price: 10.0,
                        quantity: 1,
                        specification: '85*10*86',
                        thumbnail:
                            'https://www-test.foxithd.com/b/static/media/hd_ent_logo.6138aa8f.svg',
                        unit: '个',
                        unit_price: 10.0,
                    },
                    {
                        branch: '',
                        id: 'FB0A1209-C9E5-49D9-B243-34E9ADA08972',
                        name: '三联开关',
                        price: 10.0,
                        quantity: 1,
                        specification: '86*14*86',
                        thumbnail:
                            'https://www-test.foxithd.com/b/static/media/hd_ent_logo.6138aa8f.svg',
                        unit: '个',
                        unit_price: 10.0,
                    },
                ],
                name: '硬装',
                price: 60.0,
            },
            project: { items: [], name: '工程', price: 0.0 },
        },
        name: '水电',
        price: 60.0,
    },
    mep_by_area: true,
    name: '项目',
    other: {
        items: [
            {
                branch: '',
                id: 'BD7B7A96-ABEB-4B08-0804-6D5D0C9E31BA',
                name: '设计费',
                price: 545.7250140793088,
                quantity: 54.57250140793089,
                specification: '',
                thumbnail:
                    'https://www-test.foxithd.com/b/static/media/hd_ent_logo.6138aa8f.svg',
                unit: 'm²',
                unit_price: 10.0,
            },
            {
                branch: '',
                id: '0C6AE9BE-CCBD-4865-58FB-4B37C786A41A',
                name: '材料转运及二次搬运费（无电梯 1 楼，有电梯）',
                price: 545.7250140793088,
                quantity: 54.57250140793089,
                specification: '',
                thumbnail:
                    'https://www-test.foxithd.com/b/static/media/hd_ent_logo.6138aa8f.svg',
                unit: 'm²',
                unit_price: 10.0,
            },
            {
                branch: '',
                id: 'A9202533-07CD-45DF-2F7E-7122798E9D4A',
                name: '材料转运及二次搬运费（无电梯 2 - 3 层）',
                price: 545.7250140793088,
                quantity: 54.57250140793089,
                specification: '',
                thumbnail:
                    'https://www-test.foxithd.com/b/static/media/hd_ent_logo.6138aa8f.svg',
                unit: 'm²',
                unit_price: 10.0,
            },
            {
                branch: '',
                id: '9EBC4E19-5E41-4DEA-F963-5E995EC2A26D',
                name: '材料转运及二次搬运费（无电梯 4 - 6 层）',
                price: 545.7250140793088,
                quantity: 54.57250140793089,
                specification: '',
                thumbnail:
                    'https://www-test.foxithd.com/b/static/media/hd_ent_logo.6138aa8f.svg',
                unit: 'm²',
                unit_price: 10.0,
            },
            {
                branch: '',
                id: 'F248557F-C0C6-4DB7-8365-731CFA55F7C5',
                name: '成品保护费',
                price: 545.7250140793088,
                quantity: 54.57250140793089,
                specification: '',
                thumbnail:
                    'https://www-test.foxithd.com/b/static/media/hd_ent_logo.6138aa8f.svg',
                unit: 'm²',
                unit_price: 10.0,
            },
            {
                branch: '',
                id: '3BE4D7F2-6DCC-4C9D-BBA7-31FEE65E6C2F',
                name: '垃圾清运费',
                price: 545.7250140793088,
                quantity: 54.57250140793089,
                specification: '',
                thumbnail:
                    'https://www-test.foxithd.com/b/static/media/hd_ent_logo.6138aa8f.svg',
                unit: 'm²',
                unit_price: 10.0,
            },
            {
                branch: '',
                id: 'A0F08F7A-3FB0-4991-CBDC-A0D079D2E521',
                name: '完工保洁',
                price: 545.7250140793088,
                quantity: 54.57250140793089,
                specification: '',
                thumbnail:
                    'https://www-test.foxithd.com/b/static/media/hd_ent_logo.6138aa8f.svg',
                unit: 'm²',
                unit_price: 10.0,
            },
        ],
        name: '其他',
        price: 3820.075098555162,
    },
    price: 14866.52157047738,
    rooms: [
        {
            area: 23.756678035296,
            category: {
                custom_furniture: { items: [], name: '定制', price: 0.0 },
                hard_dec: {
                    items: [
                        {
                            branch: '',
                            id: '20E11A29-FDBF-425C-1D92-99ECF701AF1C',
                            name: '天花板的亮白色',
                            price: 2149.26973493269,
                            quantity: 214.9269734932689,
                            specification: '',
                            thumbnail:
                                'https://www-test.foxithd.com/b/static/media/hd_ent_logo.6138aa8f.svg',
                            unit: 'm²',
                            unit_price: 10.0,
                        },
                        {
                            branch: '',
                            id: '54BBE448-B9F7-49E0-C401-834EA67616FC',
                            name: '天花板的亮白色',
                            price: 1840.0,
                            quantity: 184,
                            specification: '60*60',
                            thumbnail:
                                'https://www-test.foxithd.com/b/static/media/hd_ent_logo.6138aa8f.svg',
                            unit: '片',
                            unit_price: 10.0,
                        },
                        {
                            branch: '',
                            id: '29351EA5-9BE4-4BC6-64E5-90C0102B1252',
                            name: '无吊顶',
                            price: 237.56678035296,
                            quantity: 23.756678035296,
                            specification: '',
                            thumbnail:
                                'https://www-test.foxithd.com/b/static/media/hd_ent_logo.6138aa8f.svg',
                            unit: 'm²',
                            unit_price: 10.0,
                        },
                        {
                            branch: '',
                            id: 'A429E450-94D0-4CA7-FFB4-EF2B2E7C2E7A',
                            name: '4_木纹砖',
                            price: 1240.0,
                            quantity: 124,
                            specification: '200*34',
                            thumbnail:
                                'https://www-test.foxithd.com/b/static/media/hd_ent_logo.6138aa8f.svg',
                            unit: '片',
                            unit_price: 10.0,
                        },
                        {
                            branch: '',
                            id: 'E063E1CE-C377-49BD-0101-21C85315675D',
                            name: '转角窗',
                            price: 10.0,
                            quantity: 1,
                            specification: '1340*1340*1713',
                            thumbnail:
                                'https://www-test.foxithd.com/b/static/media/hd_ent_logo.6138aa8f.svg',
                            unit: '个',
                            unit_price: 10.0,
                        },
                    ],
                    name: '硬装',
                    price: 5476.83651528565,
                },
                project: {
                    category: {
                        break_work: {
                            items: [
                                {
                                    branch: '',
                                    id: '20E11A29-FDBF-425C-1D92-99ECF701AF1C-1',
                                    name: '天花板的亮白色',
                                    price: 2149.26973493269,
                                    quantity: 214.9269734932689,
                                    specification: '',
                                    thumbnail:
                                        'https://www-test.foxithd.com/b/static/media/hd_ent_logo.6138aa8f.svg',
                                    unit: 'm²',
                                    unit_price: 10.0,
                                },
                            ],
                            name: '拆建',
                            price: 0.0,
                        },
                        daub_work: { items: [], name: '涂饰', price: 0.0 },
                        install_work: { items: [], name: '安装', price: 0.0 },
                        plaster_work: {
                            items: [
                                {
                                    branch: '',
                                    id: '20E11A29-FDBF-425C-1D92-99ECF701AF1C-2',
                                    name: '天花板的亮白色',
                                    price: 2149.26973493269,
                                    quantity: 214.9269734932689,
                                    specification: '',
                                    thumbnail:
                                        'https://www-test.foxithd.com/b/static/media/hd_ent_logo.6138aa8f.svg',
                                    unit: 'm²',
                                    unit_price: 10.0,
                                },
                            ],
                            name: '泥水',
                            price: 0.0,
                        },
                        wood_work: { items: [], name: '木作', price: 0.0 },
                    },
                    name: '工程',
                    price: 0.0,
                },
                soft_dec: {
                    items: [
                        {
                            branch: '',
                            id: 'B7B8D683-B610-4B00-00FA-90A03AB8035A',
                            name: '吧台34',
                            price: 10.0,
                            quantity: 1,
                            specification: '2315*1297*1498',
                            thumbnail:
                                'https://www-test.foxithd.com/b/static/media/hd_ent_logo.6138aa8f.svg',
                            unit: '个',
                            unit_price: 10.0,
                        },
                    ],
                    name: '软装',
                    price: 10.0,
                },
            },
            id: '8FEE2452-BD25-4842-DA00-920B58F15A24',
            name: '书房',
            price: 5486.83651528565,
        },
        {
            area: 5.804459417796293,
            category: {
                custom_furniture: { items: [], name: '定制', price: 0.0 },
                hard_dec: {
                    items: [
                        {
                            branch: '',
                            id: 'F77E011D-FC44-4A75-16EE-D4AE2538A015',
                            name: '天花板的亮白色',
                            price: 2184.55475393269,
                            quantity: 218.455475393269,
                            specification: '',
                            thumbnail:
                                'https://www-test.foxithd.com/b/static/media/hd_ent_logo.6138aa8f.svg',
                            unit: 'm²',
                            unit_price: 10.0,
                        },
                        {
                            branch: '',
                            id: 'FC87CD2F-60F0-4DD4-0AEC-ED05A1AC1C28',
                            name: '天花板的亮白色',
                            price: 1840.0,
                            quantity: 184,
                            specification: '60*60',
                            thumbnail:
                                'https://www-test.foxithd.com/b/static/media/hd_ent_logo.6138aa8f.svg',
                            unit: '片',
                            unit_price: 10.0,
                        },
                        {
                            branch: '',
                            id: 'FDFC90CC-8465-411D-D6ED-477B7CB23BCE',
                            name: '4_木纹砖',
                            price: 50.0,
                            quantity: 5,
                            specification: '200*34',
                            thumbnail:
                                'https://www-test.foxithd.com/b/static/media/hd_ent_logo.6138aa8f.svg',
                            unit: '片',
                            unit_price: 10.0,
                        },
                        {
                            branch: '',
                            id: 'DF1402CD-6734-4D38-07CF-3FD251CAB4B8',
                            name: '10_纯纸墙纸',
                            price: 3.015840000000003,
                            quantity: 0.3015840000000002,
                            specification: '',
                            thumbnail:
                                'https://www-test.foxithd.com/b/static/media/hd_ent_logo.6138aa8f.svg',
                            unit: 'm²',
                            unit_price: 10.0,
                        },
                        {
                            branch: '',
                            id: 'FF60204A-964F-4799-D007-20ECC9BA0C75',
                            name: '无吊顶',
                            price: 58.04459417796294,
                            quantity: 5.804459417796293,
                            specification: '',
                            thumbnail:
                                'https://www-test.foxithd.com/b/static/media/hd_ent_logo.6138aa8f.svg',
                            unit: 'm²',
                            unit_price: 10.0,
                        },
                        {
                            branch: '',
                            id: 'D4311383-BF86-4EA4-DE81-129BD1452A9D',
                            name: '4_木纹砖',
                            price: 340.0,
                            quantity: 34,
                            specification: '200*34',
                            thumbnail:
                                'https://www-test.foxithd.com/b/static/media/hd_ent_logo.6138aa8f.svg',
                            unit: '片',
                            unit_price: 10.0,
                        },
                        {
                            branch: '',
                            id: 'ED95084C-D8FC-4B94-2C81-FB41F9319A70',
                            name: '4_木纹砖',
                            price: 12.65,
                            quantity: 1.265,
                            specification: '200*34',
                            thumbnail:
                                'https://www-test.foxithd.com/b/static/media/hd_ent_logo.6138aa8f.svg',
                            unit: 'm',
                            unit_price: 10.0,
                        },
                        {
                            branch: '',
                            id: '1D347C2A-AE0B-4B20-7756-E827CC27B7B4',
                            name: '10_纯纸墙纸',
                            price: 12.0,
                            quantity: 1.2,
                            specification: '',
                            thumbnail:
                                'https://www-test.foxithd.com/b/static/media/hd_ent_logo.6138aa8f.svg',
                            unit: 'm',
                            unit_price: 10.0,
                        },
                        {
                            branch: '',
                            id: '4F80D200-B6D1-4977-4DDA-346B02AA8A28',
                            name: '双开门',
                            price: 10.0,
                            quantity: 1,
                            specification: '1265*2000*240',
                            thumbnail:
                                'https://www-test.foxithd.com/b/static/media/hd_ent_logo.6138aa8f.svg',
                            unit: '个',
                            unit_price: 10.0,
                        },
                        {
                            branch: '',
                            id: '9872CD2C-F66E-4BF8-EA79-250E727DB7A1',
                            name: '转角窗',
                            price: 10.0,
                            quantity: 1,
                            specification: '1340*1340*1713',
                            thumbnail:
                                'https://www-test.foxithd.com/b/static/media/hd_ent_logo.6138aa8f.svg',
                            unit: '个',
                            unit_price: 10.0,
                        },
                        {
                            branch: '',
                            id: '5E2422F3-66AF-4351-F14E-D636CEF6A1D8',
                            name: '普通窗',
                            price: 10.0,
                            quantity: 1,
                            specification: '1038*1262*240',
                            thumbnail:
                                'https://www-test.foxithd.com/b/static/media/hd_ent_logo.6138aa8f.svg',
                            unit: '个',
                            unit_price: 10.0,
                        },
                    ],
                    name: '硬装',
                    price: 4530.265188110652,
                },
                project: {
                    category: {
                        break_work: { items: [], name: '拆建', price: 0.0 },
                        daub_work: { items: [], name: '涂饰', price: 0.0 },
                        install_work: { items: [], name: '安装', price: 0.0 },
                        plaster_work: { items: [], name: '泥水', price: 0.0 },
                        wood_work: { items: [], name: '木作', price: 0.0 },
                    },
                    name: '工程',
                    price: 0.0,
                },
                soft_dec: { items: [], name: '软装', price: 0.0 },
            },
            id: 'F4036064-C2C9-4FF6-98ED-9275C5C4162D',
            name: '卧室',
            price: 4530.265188110652,
        },
        {
            area: 25.01136395483859,
            category: {
                custom_furniture: { items: [], name: '定制', price: 0.0 },
                hard_dec: {
                    items: [
                        {
                            branch: '',
                            id: '9DFDE364-D724-48C2-7C8A-248EA0E1B0D9',
                            name: '天花板的亮白色',
                            price: 2150.09622753269,
                            quantity: 215.009622753269,
                            specification: '',
                            thumbnail:
                                'https://www-test.foxithd.com/b/static/media/hd_ent_logo.6138aa8f.svg',
                            unit: 'm²',
                            unit_price: 10.0,
                        },
                        {
                            branch: '',
                            id: '414C1488-7D08-4B9B-C6A9-C9F1EEC2911E',
                            name: '天花板的亮白色',
                            price: 1840.0,
                            quantity: 184,
                            specification: '60*60',
                            thumbnail:
                                'https://www-test.foxithd.com/b/static/media/hd_ent_logo.6138aa8f.svg',
                            unit: '片',
                            unit_price: 10.0,
                        },
                        {
                            branch: '',
                            id: '6E01CE42-6B62-49CD-3450-F5FFCB9531BE',
                            name: '3_抛釉砖',
                            price: 30.0,
                            quantity: 3,
                            specification: '200*200',
                            thumbnail:
                                'https://www-test.foxithd.com/b/static/media/hd_ent_logo.6138aa8f.svg',
                            unit: '片',
                            unit_price: 10.0,
                        },
                        {
                            branch: '',
                            id: 'C1C85C08-A70D-40E4-6FBD-E5FD2115B2CE',
                            name: '无吊顶',
                            price: 250.1136395483859,
                            quantity: 25.01136395483859,
                            specification: '',
                            thumbnail:
                                'https://www-test.foxithd.com/b/static/media/hd_ent_logo.6138aa8f.svg',
                            unit: 'm²',
                            unit_price: 10.0,
                        },
                        {
                            branch: '',
                            id: '917CEB21-D9A0-4AC3-D9F8-A7B1EA22E50F',
                            name: '3_抛釉砖',
                            price: 540.0,
                            quantity: 54,
                            specification: '200*200',
                            thumbnail:
                                'https://www-test.foxithd.com/b/static/media/hd_ent_logo.6138aa8f.svg',
                            unit: '片',
                            unit_price: 10.0,
                        },
                        {
                            branch: '',
                            id: 'B3AA34F9-CA0B-447D-4B47-4A21EE018C4A',
                            name: '3_抛釉砖',
                            price: 9.210000000000001,
                            quantity: 0.921,
                            specification: '200*200',
                            thumbnail:
                                'https://www-test.foxithd.com/b/static/media/hd_ent_logo.6138aa8f.svg',
                            unit: 'm',
                            unit_price: 10.0,
                        },
                        {
                            branch: '',
                            id: 'D8CD41F8-0FB6-4BEE-EB80-A2D5E180B95D',
                            name: '单开门',
                            price: 10.0,
                            quantity: 1,
                            specification: '921*2000*240',
                            thumbnail:
                                'https://www-test.foxithd.com/b/static/media/hd_ent_logo.6138aa8f.svg',
                            unit: '个',
                            unit_price: 10.0,
                        },
                        {
                            branch: '',
                            id: '1C924DFE-2086-409D-86FE-7548B99D60E8',
                            name: '普通窗',
                            price: 10.0,
                            quantity: 1,
                            specification: '1038*1262*240',
                            thumbnail:
                                'https://www-test.foxithd.com/b/static/media/hd_ent_logo.6138aa8f.svg',
                            unit: '个',
                            unit_price: 10.0,
                        },
                    ],
                    name: '硬装',
                    price: 4839.419867081076,
                },
                project: {
                    category: {
                        break_work: { items: [], name: '拆建', price: 0.0 },
                        daub_work: { items: [], name: '涂饰', price: 0.0 },
                        install_work: { items: [], name: '安装', price: 0.0 },
                        plaster_work: { items: [], name: '泥水', price: 0.0 },
                        wood_work: { items: [], name: '木作', price: 0.0 },
                    },
                    name: '工程',
                    price: 0.0,
                },
                soft_dec: {
                    items: [
                        {
                            branch: '',
                            id: '1CFBA64F-4C61-4BA0-13C7-9FADF11D3EAF',
                            name: 'L型沙发',
                            price: 10.0,
                            quantity: 1,
                            specification: '2704*1765*805',
                            thumbnail:
                                'https://www-test.foxithd.com/b/static/media/hd_ent_logo.6138aa8f.svg',
                            unit: '个',
                            unit_price: 10.0,
                        },
                    ],
                    name: '软装',
                    price: 10.0,
                },
            },
            id: 'C8FB6E81-EDE8-494C-7D56-F790E645A99D',
            name: '客厅',
            price: 4849.419867081076,
        },
    ],
    thumbnail:
        'https://www-test.foxithd.com/b/static/media/hd_ent_logo.6138aa8f.svg',
};
